import { useState, useRef, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import supportPageTitle from '../assets/support-page-title.png';
import './Header.css';

export default function Header() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const getPageTitle = () => {
    if (location.pathname === '/library') return { text: 'Library' };
    if (location.pathname === '/policy-checker') return { text: 'Policy checker' };
    if (location.pathname.startsWith('/help')) return { src: supportPageTitle, alt: 'Help center' };
    if (location.pathname === '/report-bug') return { src: supportPageTitle, alt: 'Support' };
    return null;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDropdown]);

  const handleLogout = () => {
    logout();
    setShowDropdown(false);
  };

  const handleReportBug = () => {
    navigate('/report-bug');
    setShowDropdown(false);
  };

  const handleHelpCenter = () => {
    navigate('/help');
    setShowDropdown(false);
  };

  const pageTitle = getPageTitle();

  const isHelpPage = location.pathname.startsWith('/help') || location.pathname === '/report-bug';

  return (
    <header className={`app-header ${isHelpPage ? 'help-page-header' : ''}`}>
      {pageTitle && (
        pageTitle.text
          ? <span className="page-title-text">{pageTitle.text}</span>
          : <img src={pageTitle.src} alt={pageTitle.alt} className="page-title-image" />
      )}
      <div className="header-actions">
        <div className="user-profile" ref={dropdownRef}>
          <button
            className="user-avatar"
            onClick={() => setShowDropdown(!showDropdown)}
            title={user?.email}
          >
            <span className="avatar-text">
              {user?.initials || user?.name?.[0]?.toUpperCase() || 'U'}
            </span>
            <span className="status-indicator"></span>
          </button>
          {showDropdown && (
            <div className="user-dropdown">
              <div className="dropdown-header">
                <div className="dropdown-user-name">{user?.name}</div>
                <div className="dropdown-user-email">{user?.email}</div>
              </div>
              <div className="dropdown-divider"></div>
              <button className="dropdown-item" onClick={handleHelpCenter}>
                Help Center
              </button>
              <button className="dropdown-item" onClick={handleReportBug}>
                Report an Issue
              </button>
              <button className="dropdown-item" onClick={handleLogout}>
                Sign Out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
